// Multi-site selection caps (QS-9518), shared by SiteSelect and the `site` filter.

/** Max sites selectable at once, including the current/primary site. */
export const MAX_SELECTED_SITES = 5;

/** Max additional (non-current) sites the `site` filter may hold. */
export const MAX_ADDITIONAL_SITES: number = MAX_SELECTED_SITES - 1;

export type MockSite = {
	cloudId: string;
	name: string;
};

/**
 * TODO(QS-9672 / real loading): placeholder for the additional (non-current) sites available to the
 * org. Stands in for the backend until real loading lands. Shared so the `site` filter's fetcher and
 * the SiteSelect wrapper resolve the same cloudId → name. The current/primary site is prepended at
 * runtime by the wrapper and is never in this list.
 */
export const MOCK_ADDITIONAL_SITES: MockSite[] = [
	{ cloudId: 'mock-site-b', name: 'Acme Sandbox' },
	{ cloudId: 'mock-site-c', name: 'Acme EU' },
	{ cloudId: 'mock-site-d', name: 'Acme Dev' },
];
